import { createContext, useContext, useEffect, useState } from 'react';
import { detectPricing, PRICING } from '@/utils/geoPricing';

const PricingContext = createContext(null);

export const PricingProvider = ({ children }) => {
  const [state, setState] = useState({ loading: true, country: null, country_name: '', pricing: PRICING.DEFAULT });

  useEffect(() => {
    let mounted = true;
    detectPricing().then((result) => {
      if (!mounted) return;
      setState({ loading: false, country: result.country, country_name: result.country_name, pricing: result.pricing });
    });
    return () => { mounted = false; };
  }, []);

  return <PricingContext.Provider value={state}>{children}</PricingContext.Provider>;
};

export const usePricing = () => {
  const ctx = useContext(PricingContext);
  if (!ctx) throw new Error('usePricing must be used within PricingProvider');
  return ctx;
};
